import React, { useEffect, useState } from "react";
import { Box, IconButton } from "@mui/material";
import SideNav from "../layoutsComponents/SideNav/SideNav";
import TopBar from "../layoutsComponents/TopBar/TopBar";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { http } from "../../../clients/http/http.client";
import { HTTP_ENDPOINTS, WEB_STORAGE_KEYS } from "../../../clients/clients.constants";
import { useDispatch, useSelector } from "react-redux";
import { WebStorageClient } from '../../../clients/webStorage.client'
import { setSiteId } from "../../../store/siteIdSlice";
import { useLocation } from "react-router-dom";
const { USERS } = HTTP_ENDPOINTS;

const DashboardLayout = ({ children }) => {
  const initialDrawerValue = WebStorageClient.getDrawerOpened();
  const [drawerOpen, setDrawerOpen] = useState(initialDrawerValue === null ? true : initialDrawerValue);
  const [user, setUser] = useState("");
  const [error, setError] = useState(null);
    const siteIdStore = useSelector((state) => state.siteId);

    const dispatch = useDispatch();
    const location = useLocation();

  // const isUserLoading = useSelector((state) => state.user.isUserLoading);
  const userState = useSelector((state) => state.user.user);

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
    localStorage.setItem(WEB_STORAGE_KEYS.DRAWER_OPENED, JSON.stringify(!drawerOpen));
  };

  useEffect(() => {

  }, [drawerOpen])

    useEffect(() => {
        if (location.pathname === '/home' && siteIdStore && siteIdStore.siteId === 1) {
            dispatch(setSiteId(null)); // Clear the site id in Redux state.
            localStorage.removeItem('site_id'); // Remove from local storage if stored.
        }
    }, [location.pathname, siteIdStore, dispatch]);

  // Fetch data from the API
  // useEffect(() => {
  //   http.client
  //     .get(USERS)
  //     .then((response) => {
  //       setUser(response);
  //     })
  //     .catch((err) => {
  //       setError(err.message);
  //     });
  // }, []);

  return (
    <Box sx={{ display: "flex" }}>
      {/* Side Navigation */}
      <Box
        component="nav"
        sx={{
          width: drawerOpen ? "243px" : "75px",
          // height: "1024px",
          flexShrink: 0,
          backgroundColor: "#FFF",
          boxShadow: "0px 4px 40px rgba(226, 236, 249, 0.60)",
          transition: "width 0.3s",
          overflow: "hidden",
        }}
      >
        {/* Left/Right Arrow Icon Button */}
        <IconButton
          onClick={toggleDrawer}
          sx={{
            position: "absolute",
            top: "20px",
            left: drawerOpen ? "238px" : "62px",
            transition: "left 0.3s",
            zIndex: 1234,
            backgroundColor: "#1B3665",
            borderRadius: "8px",
            padding: "0",
            border: "2px solid #FFF",
            boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)",
            color: "#FFF",
            '&:hover': {
              backgroundColor: "#042b67",
            }
          }}
        >
          {drawerOpen ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </IconButton>
        <SideNav drawerOpen={drawerOpen} />
      </Box>

      {/* Main Content */}
      <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
        {/* TopBar */}
        <Box
          component="header"
          sx={{
            // width: "1198px", // Fixed width for TopBar
            // height: "80px", // Fixed height for TopBar
            flexShrink: 0,
            backgroundColor: "#FAFBFF", // White background
          }}
        >
          <TopBar
            username={userState?.username}
            role={userState?.role}
            image_src={userState?.image_src}
            toggleDrawer={toggleDrawer}
          />
        </Box>

        {/* Content Area */}
        <Box
          sx={{
            flexGrow: 1,
            // width: "1440px", // Fixed width for the content area
            // height: "1024px", // Fixed height for the content area
            backgroundColor: "#FAFBFF", // Background color
            padding: "20px 54px 20px 54px", // Padding for content
            overflow: "auto",
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;
